import { track } from '@/services/mixpanel.service';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/nextjs';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo);

    track(error.toString());

    Sentry.captureException(error);
  }

  public render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <h1>
          Oops...something went wrong. We{"'"}ve taken note and will be looking
          into it ASAP!
        </h1>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
